import React from 'react'

const SeedList = React.memo(
  ({ savedSeeds, setGrid, setGeneration}) => {  
    return (
      <div>
        <div style={{ margin: '0 auto' }} className={'thumb-container'}>
          {savedSeeds &&
            savedSeeds.map((grid, idx) => {
              return (
                <div
                 key={`snaps-${idx}`}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <button
                  
                    className='snap-button'
                    onClick={() => {
                      setGeneration(0)
                      setGeneration(0)
                      setGrid(grid)
                    }}
                    style={{ width: '150px', transform: 'translateX(10px)' }}
                  >
                    Use Snap
                  </button>
                  <div
                    className={`gridSaves`}
                    key={`grid-${idx}`}
                    style={{
                      margin: '15px',
                      float: 'left',
                      display: 'grid',
                      gridTemplateColumns: `repeat(${grid.length},4px)`,
                      transform: 'translate(10px, 10px)'
                    }}
                  >
                    {grid.map((rows, i) =>
                      rows.map((col, k) => (
                        <div
                          key={`${i}-${k}`}
                          style={{
                            width: 2,
                            height: 2,
                            backgroundColor: grid[i][k] ? 'black' : undefined,
                            border: 'solid 1px black'
                          }}
                        ></div>
                      ))
                    )}
                    <br />
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    )
  }
)

export default SeedList
